import React, { useState, useEffect } from "react";
import "./Services.css";
import { gridItems, availableServices, descriptions } from "./data";

const Services = () => {
  const [itemWidth, setItemWidth] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const updateItemWidth = () => {
      const width = document.querySelector(".grid-item")?.offsetWidth || 0;
      setItemWidth(width);
    };

    const handleResize = () => {
      if (window.innerWidth < 500) {
        setItemsPerPage(1);
      } else {
        setItemsPerPage(3);
      }
      updateItemWidth();
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNext = () => {
    if (currentIndex < gridItems.length - itemsPerPage) {
      setCurrentIndex(currentIndex + itemsPerPage);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - itemsPerPage);
    }
  };

  return (
    <>
      <div className="service-img-container">
        <img className="Service-img" src="servimg.png" alt="service" />
      </div>

      <div className="grid-container">
        <div className="arrow-btn">
          <button className="nav-btn-left" onClick={handlePrev}>
            <img className="btn-img" src="felcha iz.png" alt="Left arrow" />
          </button>
        </div>
        <div className="grid-wrapper">
          <div
            className="grid"
            style={{
              transform: `translateX(-${currentIndex * itemWidth}px)`,
            }}
          >
            {gridItems.map((src, index) => (
              <div className="grid-item" key={index}>
                <div className="grid-item-content">
                  <div className="grid-item-img">
                    <img
                      className="grid-img"
                      src={src}
                      alt={`img ${index + 1}`}
                    />
                  </div>
                  <div className="grid-item-title">
                    <h2 translate="no" className="grid-title">{availableServices[index]}</h2>
                  </div>
                  <div className="grid-item-description">
                    <h4 className="grid-description">{descriptions[index]}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="arrow-btn">
          <button className="nav-btn-right" onClick={handleNext}>
            <img className="btn-img" src="flecha de.png" alt="Right arrow" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Services;
